import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Tooltip as MuiTooltip } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { allowedServices, getRestrictedServiceTooltipMessage, isDiscontinuedService } from 'utils';
import { canAccessCatalog } from 'utils/announcementRestrictions';
import { getDiscontinuedDescription } from 'utils/discontinuedCatalogs';
import ServiceOffered from './style';

function ServiceItem({ service }) {
    const history = useHistory();
    const disabled = !canAccessCatalog(service?.catalogDefinitionId);
    const handleNavigation = () => {
        if (!disabled) {
            history.push(service.path);
        }
    };

    const serviceContent = (
        <Box sx={ServiceOffered.ServiceItem.container} onClick={disabled ? null : handleNavigation}>
            <Box component="img" src={service.icon} alt={`${service.name} icon`} sx={ServiceOffered.ServiceItem.icon} />
            <Typography sx={ServiceOffered.ServiceItem.name}>{service.name}</Typography>
        </Box>
    );

    // If service is discontinued, wrap with a discontinued tooltip
    if (isDiscontinuedService(service?.catalogDefinitionId)) {
        return (
            <MuiTooltip
                title={getDiscontinuedDescription(service?.catalogDefinitionId)}
                arrow
                placement="top"
                componentsProps={{
                    tooltip: {
                        sx: {
                            backgroundColor: '#272727',
                            fontSize: '12px',
                            maxWidth: '300px',
                        },
                    },
                    arrow: { sx: { color: '#272727' } },
                }}
            >
                {serviceContent}
            </MuiTooltip>
        );
    }

    // If service is not allowed, wrap with a tooltip
    if (!allowedServices(service?.catalogDefinitionId)) {
        return (
            <MuiTooltip
                title={getRestrictedServiceTooltipMessage()}
                arrow
                placement="top"
                componentsProps={{
                    tooltip: {
                        sx: {
                            backgroundColor: '#272727',
                            fontSize: '12px',
                            maxWidth: '300px',
                        },
                    },
                    arrow: { sx: { color: '#272727' } },
                }}
            >
                {serviceContent}
            </MuiTooltip>
        );
    }

    return serviceContent;
}

ServiceItem.propTypes = {
    service: PropTypes.any.isRequired,
};

export default ServiceItem;
